const MultiUserIcon = ({
  size = 16,
  color = "#6A7282",
  strokeWidth = 1.333,
  isActive = false,
}) => {
  const activeColor = isActive ? "#dc2626" : color;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_multiuser)">
        <path
          d="M11.3333 13.3333H14.6667V12C14.6666 11.5844 14.5371 11.1791 14.2961 10.8404C14.0551 10.5018 13.7145 10.2467 13.3218 10.1105C12.9291 9.97435 12.5038 9.96393 12.1048 10.0807C11.7059 10.1974 11.3533 10.4356 11.096 10.762M11.3333 13.3333H4.66667M11.3333 13.3333V12C11.3333 11.5627 11.2493 11.1447 11.096 10.762M11.096 10.762C10.8484 10.1433 10.4212 9.61298 9.86933 9.23942C9.3175 8.86586 8.66639 8.6662 8 8.6662C7.33361 8.6662 6.68251 8.86586 6.13067 9.23942C5.57883 9.61298 5.15157 10.1433 4.904 10.762M4.66667 13.3333H1.33334V12C1.33337 11.5844 1.46289 11.1791 1.70391 10.8404C1.94493 10.5018 2.28546 10.2467 2.67817 10.1105C3.07088 9.97435 3.49625 9.96393 3.89516 10.0807C4.29407 10.1974 4.64669 10.4356 4.904 10.762M4.66667 13.3333V12C4.66667 11.5627 4.75067 11.1447 4.904 10.762M10 4.66667C10 5.1971 9.78929 5.70581 9.41422 6.08089C9.03914 6.45596 8.53044 6.66667 8 6.66667C7.46957 6.66667 6.96086 6.45596 6.58579 6.08089C6.21072 5.70581 6 5.1971 6 4.66667C6 4.13624 6.21072 3.62753 6.58579 3.25246C6.96086 2.87739 7.46957 2.66667 8 2.66667C8.53044 2.66667 9.03914 2.87739 9.41422 3.25246C9.78929 3.62753 10 4.13624 10 4.66667ZM14 6.66667C14 7.02029 13.8595 7.35943 13.6095 7.60948C13.3594 7.85953 13.0203 8.00001 12.6667 8.00001C12.313 8.00001 11.9739 7.85953 11.7239 7.60948C11.4738 7.35943 11.3333 7.02029 11.3333 6.66667C11.3333 6.31305 11.4738 5.97391 11.7239 5.72386C11.9739 5.47381 12.313 5.33334 12.6667 5.33334C13.0203 5.33334 13.3594 5.47381 13.6095 5.72386C13.8595 5.97391 14 6.31305 14 6.66667ZM4.66667 6.66667C4.66667 7.02029 4.52619 7.35943 4.27615 7.60948C4.0261 7.85953 3.68696 8.00001 3.33334 8.00001C2.97971 8.00001 2.64058 7.85953 2.39053 7.60948C2.14048 7.35943 2 7.02029 2 6.66667C2 6.31305 2.14048 5.97391 2.39053 5.72386C2.64058 5.47381 2.97971 5.33334 3.33334 5.33334C3.68696 5.33334 4.0261 5.47381 4.27615 5.72386C4.52619 5.97391 4.66667 6.31305 4.66667 6.66667Z"
          stroke={activeColor}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_multiuser">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default MultiUserIcon;
